// extracted by mini-css-extract-plugin
module.exports = {"AccountSelectNavigation":"styles_AccountSelectNavigation__QB7WL","select":"styles_select__W4TVY","icon":"styles_icon__IgW97"};